import React, { useContext, useEffect } from 'react';
import { 
  Route, 
  Switch, 
  Redirect,
  useHistory,
  useLocation,
 } from 'react-router-dom'; // Import Redirect if needed
import toast from 'react-hot-toast';
import MainWrapper from '../MainWrapper';
import LogIn from '../../Account/LogIn/index';
import WrappedRoutes from './WrappedRoutes';
import { AuthContext } from '../../../context/AuthContext';
import AppDashboard from '../../Dashboards/App';
import { PermissionContext } from '../../../context/PermissionContext';
import { BookingContext } from '../../../context/BookingContext';
import { RestaurantContext } from '../../../context/RestaurantContext';
import ForgotForm from '../../Account/ForgotPass';
import { Mealcontext } from '../../../context/MealContext';



const Router = () => {
  const { 
    isLoggedIn, 
    setIsLoggedIn, 
    apiGlobal,
    userid,
  } = useContext(AuthContext); 
  const { tripDataFlag, setTripDataFlag } = useContext(BookingContext);
   // Destructure from RestaurantContext
   const { 
    setclick: setRestaurantClick, 
    setActiveKey: setRestaurantActiveKey, 
    setIsDetailsClick: setRestaurantDetailsClick, 
  } = useContext(RestaurantContext);

  // Destructure from Mealcontext (Renaming to avoid conflicts)
  const { 
    setclick,
    setActiveKey,
    setIsDetailsClick,
  } = useContext(Mealcontext);

   // Define Protected Paths
   const protectedPaths = [
    '/forgotPassword',
    '/login',
    '/',
    '/app_dashboard',
    '/dashboard',
    '/admin/agent',
    '/admin/agentrequest',
    '/admin/agentRejectedRequest',
    '/admin/restaurant',
    '/admin/restaurantrequest',
    '/admin/restaurantRejectedRequest',
    '/admin/meal',
    '/admin/mealrequest',
    '/admin/mealRejectedRequest',
    '/admin/booking',
    '/admin/payment/pending',
    '/admin/payment/approved',
    '/admin/payment/reject',
    '/admin/trip',
    '/admin/currency',
    '/admin/daybook',
    '/admin/account',
    '/admin/accountrejected',
    '/admin/accountapproved',
    '/admin/pendingaccountapproval',
    '/usermanager/users',
    '/usermanager/management',
    '/admin/utility',
    '/admin/wpsetting',
    '/admin/overallaccount',
    '/admin/logs',
  ];

  const history = useHistory();
  useEffect(() => {
    const checkLoginStatus = async () => {
      try { 
        const response = await fetch(`${apiGlobal}/auth.php`);
        const data = await response.json();
        // console.log(`isLogin:${data.loggedIn}`);
        setIsLoggedIn(data.loggedIn);
        if (!data.loggedIn) {
            localStorage.clear();
            sessionStorage.clear();
          
            // Clear Cookies
            document.cookie.split(';').forEach((cookie) => {
              const name = cookie.split('=')[0].trim();
              document.cookie = `${name }=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
            });
      
            if ('caches' in window) {
              caches.keys().then((names) => {
                // eslint-disable-next-line
                for (const name of names) {
                  caches.delete(name);
                }
              });
            }
          }
      } catch (error) {
        console.error('Error checking login status:', error);
        setIsLoggedIn(false);
      }
    };

    checkLoginStatus();
  }, []); 

  // for add meal in booking
  const location = useLocation();
  useEffect(() => {
    if (location.pathname !== '/admin/meal') {
      setTripDataFlag({
        ...tripDataFlag,
        tripID: '',
        name: '',
        addMealINBooking: false,
      });
      setclick('searchSelect');
      setActiveKey('1');
      setIsDetailsClick(false);
    }

    // handler for clear all dependecies context
    if (location.pathname !== 'admin/restaurant') {
      setRestaurantClick('searchSelect');
      setRestaurantActiveKey('1');
      setRestaurantDetailsClick(false);
    }
  }, [location,
     setTripDataFlag, 
     setRestaurantClick, 
     setRestaurantActiveKey, 
     setRestaurantDetailsClick, 
     setclick, setActiveKey, 
     setIsDetailsClick]);


     const blockUserHandler = async () => {
      if (!userid) return; // Prevent unnecessary API calls if agentId is undefined/null
   
     const formdata = new FormData();
     formdata.append('user_id', userid);
     try {
       const url = await fetch(`${apiGlobal}user_block.php`, {
         method: 'POST',
         body: formdata,
       });
       const response = await url.json();
       console.log(response);
     } catch (error) {
       console.log(error);
     }
   };

     const onlogoutHandler = async () => {
          const url = await fetch(`${apiGlobal}logout.php`);
          const response = await url.json();
          if (response.loggedOut === true) {
            toast.success('Logout Successfull Redirecting....');
            setIsLoggedIn(false);
            localStorage.clear();
            setTimeout(() => {
              history.push('/');
            }, 2000);
          } else {
           toast.error('Something Went Wrong....');
          }
       };


// Handle Suspicious Activity (If the route is not in protectedPaths)
useEffect(() => {
  if (!protectedPaths.includes(location.pathname)) {
    // eslint-disable-next-line
    let suspectedCount = parseInt(localStorage.getItem('erereddf')) || 0;
    suspectedCount += 1;

    localStorage.setItem('erereddf', suspectedCount.toString());

    if (suspectedCount > 2) {
      blockUserHandler();
      onlogoutHandler();
      // setIsLoggedIn(false);
    }
  }
}, [location.pathname]); // Runs when the pathname changes





  return (
    <MainWrapper>
      <main>
        <Switch>
          {/* <Route exact path="/" component={isLoggedIn ? AppDashboard : LogIn} /> */}
          <Route 
            path="/forgotPassword" 
            component={ForgotForm} 
          />
          <Route path="/" component={isLoggedIn ? WrappedRoutes : LogIn} />
          
        </Switch>
      </main>
    </MainWrapper>
 );
};

export default Router;
